import RafThrottle from '@utilities/raf-throttle'
import ScreenDimensions from '@utilities/screen-dimensions'
import parseJSON from '@utilities/parse-json'
import Events from '@utilities/events'

const TAB_ROLE = '[role=tab]'
const TABPANEL_ROLE = '[role=tabpanel]'
const ARIA_HIDDEN = 'aria-hidden'
const ARIA_SELECTED = 'aria-selected'
const ARIA_EXPANDED = 'aria-expanded'
const TAB_COMPONENT = '[js-hook-tab-nav]'
const TAB_ACTIVE_CLASS = 'tabs__nav-button--is-active'
const TABPANEL_ACTIVE_CLASS = 'is--active'
const TABPANEL_ACTIVE_CLASS_DESKTOP = 'is--active-desktop'
const TAB_ADDITION = '-tab'
const SHOW_MORE_STORES_HOOK = 'js-hook-show-more-stores'
const SHOW_LESS_STORES_HOOK = 'js-hook-show-less-stores'
const STORE_SELECT_RESULTS_HOOK = 'js-hook-store-select-results'
const TABS_NAV_BUTTON_MAP_IS_ACTIVE = 'tabs__nav-button--map-is-active'
const SIDEBAR_MAP_IS_ACTIVE = 'store-locator__sidebar--map-is-active'
const RESULTS_MAP_IS_ACTIVE = 'store-locator__results--map-is-active'
const JS_HOOK_STORELOCATOR_LEGEND = '[js-hook-store-locator-legend]'
const SHOW_MORE_MAP_IS_ACTIVE = 'store__show-more--map-is-active'
const SHOW_LESS_MAP_IS_ACTIVE = 'store__show-less--map-is-active'

function getId(tabId) {
  return tabId.replace(TAB_ADDITION, '')
}

class TabNav {
  constructor(element) {
    this.element = element
    this.tabComponent = this.element.closest(TAB_COMPONENT)
    this.tabs = [...this.tabComponent.querySelectorAll(TAB_ROLE)]
    this.tabPanels = [...document.querySelectorAll(TABPANEL_ROLE)]
    this.desktopHidden = parseJSON(this.element.dataset.desktopHidden, false)

    this.setLayout()
    this.bindEvents()
  }

  bindEvents() {
    this.element.addEventListener('click', (event) => {
      const { currentTarget } = event
      this.updateSelectedTabAndContent(currentTarget.id)
    })

    RafThrottle.set([
      {
        element: window,
        event: 'resize',
        namespace: 'resizeTabPanels',
        fn: () => this.setLayout(),
        delay: 250,
      },
    ])

    Events.$on(`tab-nav::updated::${getId(this.element.id)}`, (event, { tabId }) =>
      this.updateSelectedTabAndContent(`${tabId}${TAB_ADDITION}`),
    )
  }

  updateSelectedTabAndContent(tabId) {
    const mapTab = document.getElementById('store-select-map-tab')
    const results = document.getElementById('store-locator-results')
    const sideBar = document.querySelector(`[${STORE_SELECT_RESULTS_HOOK}]`)
    const showMoreBtn = document.querySelector(`[${SHOW_MORE_STORES_HOOK}]`)
    const showLessBtn = document.querySelector(`[${SHOW_LESS_STORES_HOOK}]`)
    const legend = document.querySelector(JS_HOOK_STORELOCATOR_LEGEND)

    if (tabId !== this.element.id) {
      return
    }

    this.tabs.forEach((tabItem) => {

      if (tabItem.id === tabId) {
        tabItem.setAttribute(ARIA_SELECTED, 'true')
        tabItem.setAttribute(ARIA_EXPANDED, 'true')
        tabItem.classList.add(TAB_ACTIVE_CLASS)
      } else {
        tabItem.setAttribute(ARIA_SELECTED, 'false')
        tabItem.setAttribute(ARIA_EXPANDED, 'false')
        tabItem.classList.remove(TAB_ACTIVE_CLASS)
      }
      
      if (mapTab.classList.contains(TAB_ACTIVE_CLASS)) {
        mapTab.classList.add(TABS_NAV_BUTTON_MAP_IS_ACTIVE)
        sideBar.classList.add(SIDEBAR_MAP_IS_ACTIVE)
        results.classList.add(RESULTS_MAP_IS_ACTIVE)
        legend.classList.add('u-hidden');
        showMoreBtn.classList.add(SHOW_MORE_MAP_IS_ACTIVE)
        showLessBtn.classList.add(SHOW_LESS_MAP_IS_ACTIVE)
      } else {
        mapTab.classList.remove(TABS_NAV_BUTTON_MAP_IS_ACTIVE)
        sideBar.classList.remove(SIDEBAR_MAP_IS_ACTIVE)
        results.classList.remove(RESULTS_MAP_IS_ACTIVE)
        legend.classList.remove('u-hidden');
        showMoreBtn.classList.remove(SHOW_MORE_MAP_IS_ACTIVE)
        showLessBtn.classList.remove(SHOW_LESS_MAP_IS_ACTIVE)
      }
    })

    const panelId = getId(tabId)

    this.tabPanels.forEach((panelItem) => {
      if (panelItem.id === panelId) {
        panelItem.setAttribute(ARIA_HIDDEN, 'false')
        panelItem.classList.add(TABPANEL_ACTIVE_CLASS)
        panelItem.classList.add(TABPANEL_ACTIVE_CLASS_DESKTOP)
      } else {
        panelItem.setAttribute(ARIA_HIDDEN, 'true')
        panelItem.classList.remove(TABPANEL_ACTIVE_CLASS)
        panelItem.classList.remove(TABPANEL_ACTIVE_CLASS_DESKTOP)
      }
    })
  }

  setLayout() {
    if (!this.desktopHidden) {
      const direction = ScreenDimensions.isTabletLandscapeAndBigger ? 'add' : 'remove'
      this.tabPanels.forEach((panel) => panel.classList[direction](TABPANEL_ACTIVE_CLASS_DESKTOP))
    }
  }
}

export default TabNav
